// frontend/packages/business-console/src/services/pulseService.js
//
// Thin wrapper over /api/v2/console/pulse/*. Business context is
// supplied via the x-business-id header (axios interceptor in
// @upryzze/services); callers don't pass businessId.
//
// Backend lives in:
//   backend/routes/consoleRoutes.js → backend/controllers/consoleController.js
//   backend/crm/services/pulseService.ts (60s in-process cache)
//   backend/crm/lib/pulseAggregator.ts (the actual queries)

import { api } from '@upryzze/services';

export async function fetchMoneyPulse() {
  const { data } = await api.get('/v2/console/pulse/money');
  return data;
}

export async function fetchPipelinePulse() {
  const { data } = await api.get('/v2/console/pulse/pipeline');
  return data;
}

export async function fetchCrmPulse() {
  const { data } = await api.get('/v2/console/pulse/crm');
  return data;
}

export async function fetchTasksPulse() {
  const { data } = await api.get('/v2/console/pulse/tasks');
  return data;
}

export async function fetchVisibilityPulse() {
  const { data } = await api.get('/v2/console/pulse/visibility');
  return data;
}
